import { useFeatureLoyaltySurpriseModalQuery } from 'generated/sanity-graphql';
import { useFeaturesContext } from 'state/features';

export const useFeatureSurpriseModalContent = () => {
  const { featureLoyaltyUIId = '', featureIdsLoading } = useFeaturesContext();
  const { data, loading } = useFeatureLoyaltySurpriseModalQuery({
    variables: { featureLoyaltyUIId },
    skip: !featureLoyaltyUIId,
  });
  return {
    data: data?.LoyaltyUI,
    loading: featureIdsLoading || loading,
  };
};
